module.exports = __webpack_public_path__ + "assets/img/23b6a424395184fb9ce80826b1d33bff.png";